// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"eab7c577","453":"606726ba"}[chunkId] + ".chunk.js";
};